import { Button, Checkbox, message, Typography } from 'antd';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getCurrentOrganization,
  getCurrnetUserData,
  isAdmin,
} from 'store/slices/loginSlice';
import { getOrganizationCustom, updateUserSettingCustom } from 'utils/Actions';
import { fetchRoles } from 'utils/CommonFunctions';
import { capitalizeFirstLetter, UserRole } from 'utils/Constants';
const GoalWeightSettings = () => {
  const currnetOrg = useSelector(getCurrentOrganization);
  const loginUsrOrg = useSelector(getCurrnetUserData);
  const orgId = currnetOrg?.id || loginUsrOrg?.organizationID;
  const isAdminGroup = useSelector(isAdmin);

  const [allRoles, setAllRoles] = useState([]);
  const [checkRole, setCheckRole] = useState();
  const [goalLoading, setGoalLoading] = useState(false);
  const [goalFlag, setGoalFlag] = useState(false);

  const handleGetRoles = async () => {
    const rolesArray = await fetchRoles(isAdminGroup, currnetOrg);
    setAllRoles(rolesArray);
  };

  const getVisionDetails = async () => {
    try {
      let res = await getOrganizationCustom({ id: orgId });
      let GoalWeightFlag = res?.scenarioWeightsFlag;
      if (GoalWeightFlag) {
        setCheckRole(GoalWeightFlag);
      } else {
        setCheckRole(false);
      }
    } catch (err) {
      throw err;
    }
  };

  const updateGoalSetting = async () => {
    setGoalLoading(true);
    try {
      let input = {
        id: orgId,
        scenarioWeightsFlag: checkRole,
      };
      await updateUserSettingCustom(input);
      await getVisionDetails();
      message.success(`Changes saved successfully`);
      setGoalLoading(false);
    } catch (err) {
      setGoalLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    handleGetRoles();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getVisionDetails();
    // eslint-disable-next-line
  }, [goalFlag]);

  return (
    <div>
      {' '}
      <Typography.Title level={4} className="text-black fw-500 fs-20">
        Configure Goal Weight Visibility
      </Typography.Title>
      <div className="goal-weight">
        <div>
          {allRoles?.map((item, index) => {
            const roleName =
              item.name === UserRole.sme ? UserRole?.teamMember : item.name;
            const isSmeRole = item.name === UserRole?.sme;
            const isChecked = isSmeRole
              ? goalFlag
              : item.name === UserRole?.leader || item.name === UserRole?.admin;
            let defaultChecked =
              item.name === UserRole?.leader || item.name === UserRole?.admin;
            return (
              <Checkbox
                className="p-3"
                key={index}
                disabled={!isSmeRole}
                checked={defaultChecked ? true : checkRole}
                onChange={(e) =>
                  isSmeRole ? setCheckRole(e.target.checked) : undefined
                }
              >
                {capitalizeFirstLetter(roleName)}
              </Checkbox>
            );
          })}
        </div>

        <div>
          <Button
            type="primary"
            className="blue-filled-btn "
            size="middle"
            htmlType="submit"
            loading={goalLoading}
            onClick={updateGoalSetting}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(GoalWeightSettings);

